/* global gsap  */
(function app($) {
    // Selectors
    const MODAL             = $('#modal-100k');
    const IMAGES            = [...document.querySelectorAll('[data-100k-img]')];
    const BRAND_GRADIENT    = document.querySelector('[data-name="100k-gradient-color"]');
    const MASKED_100_PATH   = document.querySelector('[data-name="100k-path"]');
    const WHITE_GRADIENT    = document.querySelector('[data-name="100k-gradient"]');
    const NOT_PATIENTS_TEXT = document.querySelector('[data-name="not-patients-text"]');
    const CTA               = document.querySelector('a[data-name="100k-cta"]');

    // Constants
    const TL = gsap.timeline({ paused: true, delay: 0.5, defaults: { duration: 1.2, ease: 'power2.inOut' } }).addLabel('start');
    const MM = gsap.matchMedia();

    // Speed it up!
    // TL.timeScale(1.5);

    // Media strings
    const LG_MEDIA_STRING = '(min-width: 992px)';
    const SM_MEDIA_STRING = '(max-width: 991px)';

    // Global variables
    let desktopInitialized = false;
    let mobileInitialized  = false;

    /**
     * Get a random number
     * @param {Number} num Number
     * @returns float
     */
    const getRand = (num = 2000) => Math.random() * num;

    /**
     * Clamp a number between a minimum and maximum
     * @param {Number} num Number to clamp
     * @param {Number} min Minimum number
     * @param {Number} max Maximum number
     * @returns Number
     */
    const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

    const setModalCookie = () => {
        document.cookie = 'modal-100k-viewed=true;max-age=2592000;path=/';
    };

    /**
     * Set up the animation for the modal.
     * it should only be ran once.
     * @returns void
     */
    const initAnimationSetUp = () => {
        if (desktopInitialized) return TL.play();
        // Set the images top/bottom and left/right in random positions on the screen
        IMAGES.forEach((image, i) => {
        // Animate one of every 3 images
            const isOneInThree = i % 4 === 0;

            if (isOneInThree) {
                const topBottom = Math.random() > 0.5 ? 'top' : 'bottom';
                const leftRight = Math.random() > 0.5 ? 'left' : 'right';
                // Randomize the position of the images to come from outside of the screen, be sure not to use the same one twice
                const randTopOrBottom = clamp(getRand(2000), 1500, 2000);
                const randSides = clamp(getRand(2000), 1500, 2000);
                // Randomize the scale from with a minimum of 3
                const randomScale = clamp(Math.random() * 12, 5, 12);
                // transform
                image.style.transform = `translate(${leftRight === 'left' ? '-' : ''}${randSides}%, ${topBottom === 'top' ? '-' : ''}${randTopOrBottom}%) scale(${randomScale})`;
            } else {
            // Move the image
                const num = image.getAttribute('data-100k-img');
                const newLocation = document.querySelector(`[data-100k-masked-item="${num}"]`);
                newLocation.appendChild(image);
                // Remove the box shadow
                image.style.boxShadow = 'none';
                // remove the filter
                image.style.filter = 'blur(0)';
                // add a data attribute to the image to to show it needs to animate differently
                image.setAttribute('data-100k-img-just-fade', 'true');
            }
        });
        // Randomize the images array
        IMAGES.sort(() => Math.random() - 0.5);

        // Create an animation where the images are blurred and then unblurred and scaled down into the middle, pic images at random
        IMAGES.forEach((image, i) => {
            const justFade = image.getAttribute('data-100k-img-just-fade');
            const offset = 0.01; // 0.04 * i;
            const duration = 3 - (i * 0.01);
            if (justFade) {
                TL.to(image, { opacity: 1, duration }, `start+=${offset}`);
            } else {
                TL.to(image, {
                    scale: 1,
                    x:     0,
                    y:     0,
                    duration,
                    onStart() {
                        gsap.timeline().to(image, { duration: 0.5, opacity: 1 }).to(image, {
                            duration: 0.2,
                            filter:   'blur(0)',
                        });
                    },
                    onComplete() {
                        const num         = image.getAttribute('data-100k-img');
                        const newLocation = document.querySelector(`[data-100k-masked-item="${num}"]`);
                        const imageCopy   = image.cloneNode(true);
                        imageCopy.style.filter = 'blur(0)';
                        newLocation.appendChild(imageCopy);
                        imageCopy.style.zIndex = 0;
                        gsap.to(image, {
                            duration:   0.5,
                            opacity:    0,
                            onComplete: () => image.remove(),
                        });
                    },
                }, `start+=${offset}`);
            }
            /**
                     * Add a label to the end of the timeline so that the rest of the animations can be added to the end
                     * of the timeline AFTER all the images have been animated
                     */
            if (i === IMAGES.length - 1)
                TL.addLabel('end');
        });

        // Fade in and out at the same time
        TL.to(MASKED_100_PATH, { duration: 2, opacity: 1 }, 'end');
        TL.to('.hundred-k__digits', { duration: 3, opacity: 0 }, 'end');
        TL.to(NOT_PATIENTS_TEXT, { opacity: 0, duration: 0.5 }, 'end+=0.5');

        desktopInitialized = true;
    };

    /**
     * Set up the animation for the modal if the screen is large enough
     */
    MM.add(LG_MEDIA_STRING, initAnimationSetUp);

    /**
     * Set up the animation for the modal if the screen is small enough
     */
    MM.add(SM_MEDIA_STRING, () => {
        if (mobileInitialized) return TL.play();
        TL.fromTo(MASKED_100_PATH, { opacity: 0, duration: 3 }, { opacity: 1 }, 'end');
        mobileInitialized = true;
    });

    /**
     * As soon as the modal is shown, add class to body, this will be used in the CSS to
     * make the backdrop darker.
     */
    MODAL.on('show.bs.modal', () => document.body.classList.add('modal-100k-open'));

    // on modal shown
    MODAL.on('shown.bs.modal', () => {
        // Animate the svg path via a linear gradient from white to opacity 0 by moving the x1 and x2 values
        TL.fromTo(WHITE_GRADIENT, { attr: { x1: 0, x2: '-100%' } }, { attr: { x1: '200%', x2: '100%' }, duration: 4 }, 'end');
        TL.to('.hundred-k__fade-in', { opacity: 1, duration: 3 }, 'end');
        TL.fromTo(BRAND_GRADIENT, { attr: { x1: '-200%', x2: 0, duration: 5, ease: 'ease' } }, { attr: { x1: '100%', x2: '300%' } }, 'end+=2.5');
        TL.play();
    });

    /**
     * On closing the modal, destroy it and set the "modal-100k-viewed" cookie
     */
    MODAL.on('hidden.bs.modal', () => {
        // Reset the modal
        MODAL.modal('dispose');
        // Set the cookie
        setModalCookie();
        // Kill all the animations
        TL.kill();
        // Remove the body class
        document.body.classList.remove('modal-100k-open');
        // Remove the modal from the DOM
        MODAL.remove();
    });

    /**
     * On click of the CTA, set the cookie so that the modal does not show up on the other side.
     */
    CTA.addEventListener('click', () => setModalCookie());

    /**
     * Initialize the modal
     */
    const init = () => {
        CTA.href = CTA.dataset.href;
        // Open the modal after 1 second
        setTimeout(() => {
            MODAL.modal('show');
        }, 1000);
    };

    // equivalent of jQuery $(init)
    $(init);
}(jQuery));
